import { render } from "./TheScheduleServiceSuccess.vue?vue&type=template&id=1f2d2414"
import script from "./TheScheduleServiceSuccess.vue?vue&type=script&lang=js"
export * from "./TheScheduleServiceSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__